import { render, staticRenderFns } from "./CreateNurseForm.vue?vue&type=template&id=ba59de3a&scoped=true&"
import script from "./CreateNurseForm.vue?vue&type=script&lang=js&"
export * from "./CreateNurseForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateNurseForm.vue?vue&type=style&index=0&id=ba59de3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba59de3a",
  null
  
)

export default component.exports